import { ProfileDrawer } from "./ProfileDrawer";
import { AppAuthSetupDialog } from "./AppAuthSetupDialog";
import { ResetPasswordDialog } from "./ResetPasswordDialog";

interface UserMenuDialogsProps {
  profileOpen: boolean;
  onCloseProfile: () => void;
  appAuthSetupOpen: boolean;
  onCloseAppAuthSetup: () => void;
  appAuthEditOpen: boolean;
  onCloseAppAuthEdit: () => void;
  resetPasswordOpen: boolean;
  onCloseResetPassword: () => void;
}

export function UserMenuDialogs({
  profileOpen,
  onCloseProfile,
  appAuthSetupOpen,
  onCloseAppAuthSetup,
  appAuthEditOpen,
  onCloseAppAuthEdit,
  resetPasswordOpen,
  onCloseResetPassword,
}: UserMenuDialogsProps) {
  return (
    <>
      <ProfileDrawer open={profileOpen} onClose={onCloseProfile} />
      <AppAuthSetupDialog
        open={appAuthSetupOpen}
        mode="setup"
        onClose={onCloseAppAuthSetup}
      />
      <AppAuthSetupDialog
        open={appAuthEditOpen}
        mode="edit"
        onClose={onCloseAppAuthEdit}
      />
      <ResetPasswordDialog
        open={resetPasswordOpen}
        onClose={onCloseResetPassword}
      />
    </>
  );
}
